import styled from 'styled-components/macro';

import media from 'helpers/media';

export {
    Description,
    Header,
    LearnMoreLink,
    LegalLinksConversion,
    SectionPlans,
    ColumnHeaders,
    ColumnPlans,
    DesktopHero,
    SectionConversion,
} from 'pages/BlackFriday/Landing/styled';

export const MobileHero = styled.div<{ $bg: string }>`
    display: none;
    background-size: cover;
    height: 320px;
    background-image: ${({ $bg }) => `url('${$bg}')`};

    ${media.toTablet`display: block;`}

    @media screen and (max-width: 375px) {
        height: 120px;
    }

    @media screen and (min-width: 376px) and (max-width: 469px) {
        height: 150px;
    }

    @media screen and (min-width: 470px) and (max-width: 600px) {
        height: 180px;
    }

    @media screen and (min-width: 601px) and (max-width: 700px) {
        height: 210px;
    }
`;
